import { render, staticRenderFns } from "./DigitalPanel.vue?vue&type=template&id=cab011c4&scoped=true&"
import script from "./DigitalPanel.vue?vue&type=script&lang=js&"
export * from "./DigitalPanel.vue?vue&type=script&lang=js&"
import style0 from "./DigitalPanel.vue?vue&type=style&index=0&id=cab011c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab011c4",
  null
  
)

export default component.exports